import { Typography } from '@mui/material';
import MenuPopover from '../menu-popover';
import { EXTERNAL_PLATFORM_ACTION_MESSAGE } from './externalPlatformMessage';

interface ExternalPlatformActionPopoverProps {
  anchorEl: HTMLElement | null;
  onClose: VoidFunction;
}

export function ExternalPlatformActionPopover({
  anchorEl,
  onClose,
}: ExternalPlatformActionPopoverProps) {
  return (
    <MenuPopover open={anchorEl} onClose={onClose} arrow="top-center" sx={{ maxWidth: 320, p: 2 }}>
      <Typography variant="body2">{EXTERNAL_PLATFORM_ACTION_MESSAGE}</Typography>
    </MenuPopover>
  );
}
